import { render, staticRenderFns } from "./BusinessUnitList.vue?vue&type=template&id=b2b21a3e&scoped=true&"
import script from "./BusinessUnitList.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b21a3e",
  null
  
)

export default component.exports